import React from "react";
import { Link } from "react-router-dom";
const Poster = (props) =>{
    return (
        <>

<Link to={`/movie/${props.id}`}>


        <div className=" mx-auto flex flex-col items-center px-1 mt-20 mb-6">
            <div className="h-80 rounded-lg hover:shadow-xl hover:shadow-slate-600 transition-all duration-300">
    <img  src={`https://image.tmdb.org/t/p/original${props.poster_path}`} 
    alt={props.original_title} className="w-full h-full rounded-xl"/>
            </div>
            {/*  for heading->title */}
            <h3 className={`text-lg font-bold not-italic ${
                props.isDark ?"text-white" : "text-gray-700"
            }`}
            >{props.title}</h3>

            {/* for the paragraph->Descrp */}
           <p className={`text-sm font-semibold not-italic ${
               props.isDark ?"text-white" : "text-gray-500"
            }`}>{props.subtitle}</p>
        </div>
            </Link>
        </>
    )

};
export default Poster;